import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { LoginComponent } from './auth/pages/login/login.component';
import { RegisterComponent } from './auth/pages/register/register.component';
import { ForgotPasswordComponent } from './auth/pages/forgot-password/forgot-password.component';
import { HomeComponent } from './dashboard/pages/home/home.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { CountryComponent } from './dashboard/pages/country/country.component';
import { authGuard } from './auth.guard';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { UserProfileComponent } from './dashboard/pages/user-profile/user-profile.component';
import { HelpCenterComponent } from './dashboard/pages/help-center/help-center.component';
import { InsidePageNotFoundComponent } from './dashboard/components/inside-page-not-found/inside-page-not-found.component';
import { PrivacyPolicyComponent } from './auth/pages/privacy-policy/privacy-policy.component';
import { APIDocumentaionComponent } from './dashboard/pages/apidocumentaion/apidocumentaion.component';
import { MenuModelComponent } from './dashboard/pages/menu-model/menu-model.component';
import { CityComponent } from './dashboard/pages/city/city.component';
import { DoctorComponent } from './dashboard/pages/doctor/doctor.component';
import { BankComponent } from './dashboard/pages/bank/bank.component';
import { CashDeskComponent } from './dashboard/pages/cash-desk/cash-desk.component';
import { CheckComponent } from './dashboard/pages/check/check.component';
import { CompanyComponent } from './dashboard/pages/company/company.component';
import { DrugComponent } from './dashboard/pages/drug/drug.component';
import { DrugFormComponent } from './dashboard/pages/drug-form/drug-form.component';
import { TechnicalRightComponent } from './dashboard/pages/technical-right/technical-right.component';
import { InsurancesComponent } from './dashboard/pages/insurances/insurances.component';
import { PatientComponent } from './dashboard/pages/patient/patient.component';
import { DrugStoreComponent } from './dashboard/pages/drug-store/drug-store.component';
import { DrugUsageComponent } from './dashboard/pages/drug-usage/drug-usage.component';
import { BankAccountComponent } from './dashboard/pages/bank-account/bank-account.component';
import { DoctorSpecialtyComponent } from './dashboard/pages/doctor-specialty/doctor-specialty.component';
import { KeepingTypeComponent } from './dashboard/pages/keeping-type/keeping-type.component';
import { PersianHolidayComponent } from './dashboard/pages/persian-holiday/persian-holiday.component';
import { PhonebookComponent } from './dashboard/pages/phonebook/phonebook.component';
import { SellerComponent } from './dashboard/pages/seller/seller.component';
import { UserComponent } from './dashboard/pages/user/user.component';
import { BuyComponent } from './dashboard/pages/buy/buy.component';
import { StockComponent } from './dashboard/pages/stock/stock.component';
import { SaleComponent } from './dashboard/pages/sale/sale.component';
import { CheckbookComponent } from './dashboard/pages/checkbook/checkbook.component';
import { PositionComponent } from './dashboard/pages/position/position.component';
import { DrugGenericComponent } from './dashboard/pages/drug-generic/drug-generic.component';
import { CheckBookTypeComponent } from './dashboard/pages/check-book-type/check-book-type.component';
import { CheckBookCountComponent } from './dashboard/pages/check-book-count/check-book-count.component';
import { AdminStockComponent } from './dashboard/pages/admin-stock/admin-stock.component';
import { FastSaleComponent } from './dashboard/pages/fast-sale/fast-sale.component';
import { WarehouseHandlingModalComponent } from './dashboard/components/warehouse-handling-modal/warehouse-handling-modal.component';
import { CalenderComponent } from './dashboard/components/calender/calender.component';
import { NotificationComponent } from './dashboard/components/notification/notification.component';
import { TaminAuthorizComponent } from './dashboard/pages/tamin-authoriz/tamin-authoriz.component';
import { DrugDistributorComponent } from './dashboard/pages/drug-distributor/drug-distributor.component';
import { CosmeticComponent } from './dashboard/pages/cosmetic/cosmetic.component';
import { EssentialsComponent } from './dashboard/pages/essentials/essentials.component';
import { MilkPowderComponent } from './dashboard/pages/milk-powder/milk-powder.component';
import { NaturalRemedyComponent } from './dashboard/pages/natural-remedy/natural-remedy.component';
import { SupplementComponent } from './dashboard/pages/supplement/supplement.component';
import { TraditionalDrugComponent } from './dashboard/pages/traditional-drug/traditional-drug.component';
import { BuyPreInvoiceComponent } from './dashboard/pages/buy-pre-invoice/buy-pre-invoice.component';
import { ElectronicPrescriptionComponent } from './dashboard/pages/electronic-prescription/electronic-prescription.component';
import { ChangeDrugSupportComponent } from './dashboard/pages/change-drug-support/change-drug-support.component';
import { SalesReportComponent } from './dashboard/pages/sales-report/sales-report.component';
import { ReportCalenderComponent } from './dashboard/pages/report-calender/report-calender.component';
import { DrugGroupComponent } from './dashboard/pages/drug-group/drug-group.component';
import { TransferBetweenStockComponent } from './dashboard/pages/transfer-between-stock/transfer-between-stock.component';
import { WarehouseHandlingComponent } from './dashboard/pages/warehouse-handling/warehouse-handling.component';
import { ChangePricingComponent } from './dashboard/pages/change-pricing/change-pricing.component';
import { WarehouseHandlingReportComponent } from './dashboard/pages/warehouse-handling-report/warehouse-handling-report.component';
import { SaleListComponent } from './dashboard/pages/sale-list/sale-list.component';
import { FactorListComponent } from './dashboard/pages/factor-list/factor-list.component';
import { SaleCosmeticComponent } from './dashboard/pages/sale-cosmetic/sale-cosmetic.component';
import { InsuranceReportComponent } from './dashboard/pages/insurance-report/insurance-report.component';
import { UserAccountSettingComponent } from './dashboard/pages/user-account-setting/user-account-setting.component';
import { CheckoutComponent } from './dashboard/pages/checkout/checkout.component';
import { PosDeviceComponent } from './dashboard/pages/pos-device/pos-device.component';
import { BarcodeComponent } from './dashboard/components/barcode/barcode.component';
import { BarcodeGeneratorComponent } from './dashboard/pages/barcode-generator/barcode-generator.component';
import { LoggerGuard } from './guards/logger.guard';
import { POSTypeComponent } from './dashboard/pages/postype/postype.component';
import { FactorTableComponent } from './dashboard/components/factor-table/factor-table.component';
import { FactorReportComponent } from './dashboard/pages/factor-report/factor-report.component';
import { SalePreInvoiceComponent } from './dashboard/pages/sale-pre-invoice/sale-pre-invoice.component';
import { InventoryReconciliationComponent } from './dashboard/pages/inventory-reconciliation/inventory-reconciliation.component';
import { InventoryTransferComponent } from './dashboard/pages/inventory-transfer/inventory-transfer.component';
import { DigitalPrescriptionSalamatComponent } from './dashboard/components/digital-prescription-salamat/digital-prescription-salamat.component';
import { ScarceDrugComponent } from './dashboard/pages/scarce-drug/scarce-drug.component';
import { RareDrugComponent } from './dashboard/pages/rare-drug/rare-drug.component';

// **************************************************

// **************************************************

const routes: Routes = [
  //Site routes goes here

  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        title: 'Login',
        component: LoginComponent,
      },

      {
        path: 'register',
        title: 'Register',
        component: RegisterComponent,
      },
      {
        path: 'privacypolicy',
        title: 'Privacy Policy',
        component: PrivacyPolicyComponent,
      },
      {
        path: 'forgotPassword',
        title: 'Forgot Password',
        component: ForgotPasswordComponent,
      },
    ],
  },

  //App routes goes here here
  {
    path: '',
    component: DashboardLayoutComponent,
    children: [
      {
        path: 'TaminAuthorizdetail',
        component: TaminAuthorizComponent,
        canActivate: [authGuard, LoggerGuard],
        pathMatch: 'full',
        children: [
          {
            path: '',
            component: TaminAuthorizComponent,
            canActivate: [authGuard, LoggerGuard],
          },
          {
            path: '',
            component: TaminAuthorizComponent,
            canActivate: [authGuard, LoggerGuard],
            pathMatch: 'full',
            resolve: {
              code: ActivatedRouteSnapshot,
              expires_in: ActivatedRouteSnapshot,
            },
          },
        ],
      },
      {
        path: 'TechnicalRight',
        title: 'Technical Right',
        component: TechnicalRightComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Insurances',
        title: 'Insurances',
        component: InsurancesComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'Patient',
        title: 'Patient',
        component: PatientComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'DrugGroup',
        title: 'DrugGroup',
        component: DrugGroupComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'DrugForm',
        title: 'DrugForm',
        component: DrugFormComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'WarehouseHandlingModal',
        title: 'WarehouseHandlingModal',
        component: WarehouseHandlingModalComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'InventoryReconciliation',
        title: 'InventoryReconciliation',
        component: InventoryReconciliationComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'InventoryTransfer',
        title: 'InventoryTransfer',
        component: InventoryTransferComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'ScarceDrug',
        title: 'ScarceDrug',
        component: ScarceDrugComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'RareDrug',
        title: 'RareDrug',
        component: RareDrugComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Buy',
        title: 'Buy',
        component: BuyComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'AdminStock',
        title: 'AdminStock',
        component: AdminStockComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'DrugStore',
        title: 'DrugStore',
        component: DrugStoreComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Sale',
        title: 'Sale',
        component: SaleComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'SalamatElectronicPrescription',
        title: 'SalamatElectronicPrescription',
        component: DigitalPrescriptionSalamatComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'SalePreInvoice',
        title: 'SalePreInvoice',
        component: SalePreInvoiceComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'DrugDistributor',
        title: 'DrugDistributor',
        component: DrugDistributorComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'DrugUsage',
        title: 'DrugUsage',
        component: DrugUsageComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'DoctorSpecialty',
        title: 'DoctorSpecialty',
        component: DoctorSpecialtyComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'CashDesk',
        title: 'Cash Desk',
        component: CashDeskComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'BuyPreInvoice',
        title: 'Buy Previous',
        component: BuyPreInvoiceComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'SaleCosmetic',
        title: 'SaleCosmetic',
        component: SaleCosmeticComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'backToCash',
        title: 'Cash Desk',
        component: CashDeskComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Menu',
        title: 'Menu Model',
        component: MenuModelComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'Check',
        title: 'Check',
        component: CheckComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'CheckBook',
        title: 'CheckBook',
        component: CheckbookComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Company',
        title: 'Company',
        component: CompanyComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Notifications',
        title: 'Notifications',
        component: NotificationComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'BankAccount',
        title: 'Bank Account',
        component: BankAccountComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Bank',
        title: 'Bank',
        component: BankComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'helpCenter',
        title: 'Help Center',
        component: HelpCenterComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'userprofile',
        title: 'User Profile',
        component: UserProfileComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'ChangeDrug',
        title: 'ChangeDrug',
        component: ChangeDrugSupportComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'ChangePricing',
        title: 'ChangePricing',
        component: ChangePricingComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'ReportCalender',
        title: 'ReportCalender',
        component: ReportCalenderComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'SaleReport',
        title: 'SaleReport',
        component: SalesReportComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'SaleList',
        title: 'SaleList',
        component: SaleListComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'FactorList',
        title: 'FactorList',
        component: FactorListComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'User',
        title: 'User',
        component: UserComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'home',
        title: 'Home',
        component: HomeComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'CheckBookType',
        title: 'Check Book Type',
        component: CheckBookTypeComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'InsuranceReport',
        title: 'InsuranceReport',
        component: InsuranceReportComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'CheckBookCount',
        title: 'Check Book Count',
        component: CheckBookCountComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'DrugGeneric',
        title: 'Drug Generic',
        component: DrugGenericComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Position',
        title: 'Position',
        component: PositionComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'ApiDocumentation',
        title: 'Api Documentation',
        component: APIDocumentaionComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Doctor',
        title: 'Doctor',
        component: DoctorComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Drug',
        title: 'Drug',
        component: DrugComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Barcode',
        title: 'Barcode',
        component: BarcodeGeneratorComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'UserAccountSetting',
        title: 'UserAccountSetting',
        component: UserAccountSettingComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'PosDevice',
        title: 'PosDevice',
        component: PosDeviceComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Checkout',
        title: 'Checkout',
        component: CheckoutComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Cosmetic',
        title: 'Cosmetic',
        component: CosmeticComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Essentials',
        title: 'Essentials',
        component: EssentialsComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'MilkPowder',
        title: 'MilkPowder',
        component: MilkPowderComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'NaturalRemedy',
        title: 'NaturalRemedy',
        component: NaturalRemedyComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Supplement',
        title: 'Supplement',
        component: SupplementComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'TraditionalDrug',
        title: 'TraditionalDrug',
        component: TraditionalDrugComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'country',
        title: 'Country',
        component: CountryComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'city',
        title: 'City',
        component: CityComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'bankaccount',
        title: 'BankAccount',
        component: BankAccountComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'doctorspecialty',
        title: 'DoctorSpecialty',
        component: DoctorSpecialtyComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'FactorTable',
        title: 'FactorTable',
        component: FactorTableComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'FactorReport',
        title: 'FactorReport',
        component: FactorReportComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Stock',
        title: 'Stock',
        component: StockComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'POSType',
        title: 'POSType',
        component: POSTypeComponent,
        canActivate: [authGuard, LoggerGuard],
      },

      {
        path: 'KeepingType',
        title: 'KeepingType',
        component: KeepingTypeComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'PersianHoliday',
        title: 'PersianHoliday',
        component: PersianHolidayComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'TransferBetweenStock',
        title: 'TransferBetweenStock',
        component: TransferBetweenStockComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'WarehouseHandling',
        title: 'WarehouseHandling',
        component: WarehouseHandlingComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Phonebook',
        title: 'Phonebook',
        component: PhonebookComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Calender',
        title: 'Calender',
        component: CalenderComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: 'Seller',
        title: 'Seller',
        component: SellerComponent,
        canActivate: [authGuard, LoggerGuard],
      },
      {
        path: '**',
        title: '۴۰۴',
        component: InsidePageNotFoundComponent,
      },
    ],
  },

  {
    path: 'notauthorized',
    title: 'Not Authorized',
    component: NotAuthorizedComponent,
  },

  {
    path: '**',
    title: '۴۰۴',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
